<template>
  <div>
    <page-header
      icon="mdi-warehouse"
      :title="$t('routes.warehouse')"
      :subtitle="$t('manage_warehouse_inventory')"
    />

    <page-toolbar
      v-model="search"
      :search-placeholder="$t('search_warehouse_placeholder')"
    >
      <template #filters>
        <v-col cols="auto">
          <date-picker v-model="dates" color="white" />
        </v-col>

        <v-col cols="auto">
          <autocomplete
            v-model="byMeal"
            :items="[
              { text: $t('per_meal'), val: 1 },
              { text: $t('total'), val: 0 },
            ]"
            item-text="text"
            item-value="val"
            :label="$t('type_of_review')"
            color="white"
          />
        </v-col>
      </template>
    </page-toolbar>
    <div class="px-6 mt-2">
      <v-row no-gutters align="center" justify="space-between" class="primary">
        <v-col>
          <v-tabs v-model="tab" align-with-title background-color="primary" dark>
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab @click="printTable = item" v-for="item in items" :key="item">
              {{ $t(item) }}
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="auto">
          <v-btn :to="{ name: 'warehouse' }" text color="white" class="mr-2">
            Magacin v2
          </v-btn>
        </v-col>
      </v-row>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <template v-if="byMeal">
              <template v-for="(items, i) in report">
                <v-col cols="12">
                  <v-row id="tr" class="pl-5">
                    <h3 class="headline_tab">{{ $t("tr") }}</h3>
                    <v-col cols="12">
                      <h2 class="mt-3 nar">
                        {{ $t("order_date") }}: {{ formatDate(dates[0]) }} -
                        {{ formatDate(dates[1]) }}
                      </h2>
                    </v-col>
                    <v-col class="firme" cols="12">
                      <autocomplete
                        v-model="search1"
                        :items="Object.keys(items)"
                        multiple
                        :label="$t('meal')"
                        item-text="name"
                        clear
                        chips
                        small-chips
                        select-all
                      />
                    </v-col>
                    <template v-if="search1.length > 0" v-for="(meal, ii) in search1">
                      <div style="width: 100%">
                        <strong class="naslov">
                          {{ toLatin(meal.toUpperCase()) }}:
                          {{ items[meal].quantity }}
                          <span class="text-decoration-underline">{{
                            $t("pieces")
                          }}</span> </strong
                        ><br />
                        <v-data-table
                          :headers="headers2"
                          class="ordera-box-shadow striped-table"
                          :items="items[meal].groceries"
                          :items-per-page="-1"
                          :search="search"
                        >
                          <template
                            v-for="header in headers2"
                            v-slot:[`header.${header.value}`]="{ header }"
                          >
                            {{ $t(header.text) }}
                          </template>
                          <template
                            v-for="values in headers2"
                            v-slot:[`item.${values.value}`]="{ item }"
                          >
                            {{ translate(item[values.value]) }}
                          </template>
                          <template v-slot:item.quantityTotal="{ item }">
                            {{
                              Math.round(
                                (item.quantity * items[meal].quantity + Number.EPSILON) *
                                  1e10
                              ) / 1e10
                            }}
                          </template>
                        </v-data-table>
                      </div>
                    </template>
                    <template v-else-if="search1.length == 0" v-for="(meal, ii) in items">
                      <v-col id="tr" cols="12" class="pt-4" style="width: 100%">
                        <strong
                          >{{ translate(ii.toUpperCase()) }}:
                          {{ meal.quantity }}
                          <span class="text-decoration-underline">{{
                            $t("pieces")
                          }}</span> </strong
                        ><br />
                        <v-data-table
                          :headers="headers2"
                          :items="meal.groceries"
                          class="ordera-box-shadow striped-table"
                          :items-per-page="-1"
                          :search="search"
                        >
                          <template
                            v-for="header in headers2"
                            v-slot:[`header.${header.value}`]="{ header }"
                          >
                            {{ $t(header.text) }}
                          </template>
                          <template
                            v-for="values in headers2"
                            v-slot:[`item.${values.value}`]="{ item }"
                          >
                            {{ translate(item[values.value]) }}
                          </template>
                          <template v-slot:item.quantityTotal="{ item }">
                            {{
                              Math.round(
                                (item.quantity * meal.quantity + Number.EPSILON) * 1e10
                              ) / 1e10
                            }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </template>
                  </v-row>
                </v-col>
              </template>
            </template>
            <v-col id="tr" v-else cols="12" class="pt-4">
              <h1 class="text-center">{{ $t("total") }}</h1>
              <h4 class="text-center">
                {{ $t("total_groceries_for_selected_period") }}
              </h4>
              <br />
              <v-data-table
                :headers="headers3"
                :items="total"
                :search="search"
                :items-per-page="15"
                class="ordera-box-shadow striped-table"
              >
                <template
                  v-for="header in headers3"
                  v-slot:[`header.${header.value}`]="{ header }"
                >
                  <span style="display: flex; align-items: center">
                    {{ $t(header.text) }}
                    <span v-if="header.value == 'action'">
                      <v-checkbox
                        @change="selectAllGroceries"
                        hide-details
                        v-model="all_items"
                      ></v-checkbox>
                    </span>
                  </span>
                </template>
                <template
                  v-for="values in headers2"
                  v-slot:[`item.${values.value}`]="{ item }"
                >
                  {{ translate(item[values.value]) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-checkbox hide-details v-model="item.checked"></v-checkbox>
                </template>
                <template v-slot:item.quantity="{ item }">
                  {{ Math.round((item.quantity + Number.EPSILON) * 1e10) / 1e10 }}
                </template>
                <template v-for="values in headers" v-slot:item.num="{ item, index }">
                  {{ index + 1 }}
                </template>
              </v-data-table>

              <v-col cols="12" v-if="total && total.length">
                <v-btn color="primary" block @click="takeOff">{{ $t("give_out") }}</v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item class="fill-height">
          <div id="st_mag">
            <h3 class="headline_tab headline_mag">
              {{ $t("st_mag") }}
            </h3>
            <v-data-table
              :headers="headers"
              :items="desserts"
              :search="search"
              :items-per-page="15"
              class="ordera-box-shadow striped-table"
            >
              <template
                v-for="header in headers"
                v-slot:[`header.${header.value}`]="{ header }"
              >
                {{ $t(header.text) }}
              </template>
              <template
                v-for="values in headers"
                v-slot:[`item.${values.value}`]="{ item }"
              >
                {{ translate(item[values.value]) }}
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <global-dialog-card
                    v-model="dialog"
                    max-width="500px"
                    :title="formTitle"
                  >
                    <v-container>
                      <v-row>
                        <v-col cols="auto">
                          {{ $t("grocery") }}: {{ editedItem.name }}
                        </v-col>
                        <v-col cols="auto">
                          {{ $t("warehouse_code") }}:
                          {{ editedItem.code }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="auto">
                          <strong>{{ $t("in_stock") }}: {{ editedItem.total }}</strong>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <text-field
                            type="number"
                            v-model="editedItem.amount"
                            :label="$t('new_entry')"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                    <template #actions>
                      <v-btn text @click="close">
                        {{ $t("cancel") }}
                      </v-btn>
                      <primary-button @click="save">
                        {{ $t("save") }}
                      </primary-button>
                    </template>
                  </global-dialog-card>
                  <global-dialog-card
                    v-model="dialogIzlaz"
                    :title="$t('warehouse_store_exit')"
                  >
                    <v-container>
                      <v-row>
                        <v-col cols="auto">
                          {{ $t("grocery") }}: {{ editedItem.name }}
                        </v-col>
                        <v-col cols="auto">
                          {{ $t("warehouse_code") }}:
                          {{ editedItem.code }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="auto">
                          <strong>{{ $t("in_stock") }}: {{ editedItem.total }}</strong>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <text-field
                            type="number"
                            v-model="editedItem.amount_off"
                            :label="$t('subtract_quantity')"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                    <template #actions>
                      <v-btn text @click="closeIzlaz">
                        {{ $t("cancel") }}
                      </v-btn>
                      <primary-button @click="save">
                        {{ $t("save") }}
                      </primary-button>
                    </template>
                  </global-dialog-card>
                  <global-dialog-card
                    v-model="dialogUlaz"
                    :title="$t('store_warehouse_entry')"
                  >
                    <v-container>
                      <v-row>
                        <v-col cols="auto">
                          {{ $t("grocery") }}: {{ editedItem.name }}
                        </v-col>
                        <v-col cols="auto">
                          {{ $t("warehouse_code") }}:
                          {{ editedItem.code }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="auto">
                          <strong>{{ $t("in_stock") }}: {{ editedItem.total }}</strong>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <text-field
                            type="number"
                            v-model="editedItem.amount_in"
                            :label="$t('add_quantity')"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                    <template #actions>
                      <v-btn text @click="closeUlaz">
                        {{ $t("cancel") }}
                      </v-btn>

                      <primary-button @click="save">
                        {{ $t("save") }}
                      </primary-button>
                    </template>
                  </global-dialog-card>
                </v-toolbar>
              </template>

              <template v-slot:item.actions="{ item }">
                <circle-button class="mr-2" @click="editItemUlaz(item)" icon="mdi-plus" />
                <circle-button
                  @click="editItemIzlaz(item)"
                  class="mr-2"
                  icon="mdi-minus"
                />

                <edit-button class="mr-2" @click="editItem(item)"></edit-button>
              </template>
            </v-data-table>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <global-dialog-card v-model="give_out" :title="$t('give_out')">
      <v-row>
        <v-col cols="4">
          <date-picker v-model="set_date" single-date />
        </v-col>
        <v-col cols="4">
          <autocomplete
            v-model="user_give_out"
            :items="warehouse_users"
            hide-details
            :label="$t('give_out_goods')"
            item-value="id"
            item-text="name"
          />
          <autocomplete
            v-model="user_give_in"
            :items="warehouse_users"
            hide-details
            item-text="name"
            :label="$t('give_in_goods')"
            item-value="id"
          />
        </v-col>
        <v-col cols="4">
          <text-area
            v-model="warehouse_note"
            :label="$t('note')"
            rows="4"
            auto-grow
          ></text-area>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table
          :headers="headers4"
          :items="selected_groceries"
          :search="search"
          :items-per-page="15"
          class="ordera-box-shadow striped-table"
        >
          <template
            v-for="header in headers4"
            v-slot:[`header.${header.value}`]="{ header }"
          >
            {{ $t(header.text) }}
          </template>
          <template v-for="values in headers2" v-slot:[`item.${values.value}`]="{ item }">
            {{ translate(item[values.value]) }}
          </template>
          <template v-slot:item.edit="{ item }">
            <text-field
              style="width: 70%; margin-left: auto"
              v-model="item.amount"
              type="number"
              :label="$t('give_out')"
            />
          </template>
          <template v-slot:item.quantity="{ item }">
            {{ Math.round((item.quantity + Number.EPSILON) * 1e10) / 1e10 }}
          </template>
          <template v-for="values in headers" v-slot:item.num="{ item, index }">
            {{ index + 1 }}
          </template>
        </v-data-table>
      </v-row>
      <template #actions>
        <v-btn text @click="give_out = false">
          {{ $t("cancel") }}
        </v-btn>
        <primary-button @click="saveGiveOut">
          {{ $t("give_out") }}
        </primary-button>
      </template>
    </global-dialog-card>
  </div>
</template>

<script>
import moment from "moment";
import hasSnackbar from "@/mixins/hasSnackbar";
import groceryService from "@/services/grocery";
import warehouseService from "@/services/warehouse";
import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  components: {
    PageHeader,
    PageToolbar,
  },
  mixins: [hasSnackbar],
  data() {
    return {
      printTable: "tr",
      search: null,
      search1: [],
      pretraga: null,
      moment: moment,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      set_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      set_menu: false,
      give_out: false,
      byMeal: 1,
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ],
      menu2: false,
      report: null,
      tab: null,
      tab1: null,
      items: ["tr", "st_mag"],
      user_give_out: "",
      user_give_in: "",
      warehouse_note: "",
      all_items: false,
      dialog: false,
      dialogIzlaz: false,
      dialogUlaz: false,
      dialogPopis: false,
      headers: [
        { text: "Id", value: "id", align: "start" },
        { text: "item_code", value: "code", align: "start" },
        { text: "name", value: "name" },
        { text: "total", value: "total" },
        { text: "q", value: "measure", sortable: false },
        { text: "actions", value: "actions", sortable: false },
      ],
      headers2: [
        { text: "item_code", value: "code" },
        { text: "grocery", value: "name" },
        { text: "nor", value: "quantity", align: "end" },
        { text: "total", value: "quantityTotal", align: "end" },
        { text: "q", value: "measure", align: "end" },
      ],
      headers3: [
        { text: "r_b", value: "num", align: "start" },
        { text: "choose", value: "action", align: "start" },
        { text: "item_code", value: "code" },
        { text: "title", value: "name" },
        { text: "quantity", value: "quantity", align: "start" },
        { text: "q", value: "measure", align: "start" },
      ],
      headers4: [
        { text: "item_code", value: "code" },
        { text: "title", value: "name" },
        { text: "current_quantity", value: "quantity", align: "end" },
        { text: "issued_quantity", value: "edit", align: "end" },
        { text: "q", value: "measure", align: "end" },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        total: 0,
        amount_in: 0,
        amount_off: 0,
      },
      defaultItem: {
        name: "",
        total: 0,
        amount_in: 0,
        amount_off: 0,
      },
      items1: [
        { text: "per_meal", val: 1 },
        { text: "total", val: 0 },
      ],
      selected_groceries: [],
      warehouse_users: "",
    };
  },
  created() {
    this.loadGrocery();
    this.getWarehouseUsers();
    this.load();
  },
  methods: {
    selectAllGroceries() {
      if (this.all_items) {
        this.total.filter((item) => {
          item.checked = true;
        });
      }
      if (!this.all_items) {
        this.total.filter((item) => {
          item.checked = false;
        });
      }
    },
    getWarehouseUsers() {
      warehouseService
        .getWarehouseUsersOld({
          restaurant_id: this.$store.state.restaurant.id,
        })
        .then(({ data }) => {
          if (data) {
            this.warehouse_users = data;
          }
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_users"));
        });
    },
    saveGiveOut() {
      let podaci = {};
      podaci["document_type"] = "exit";
      podaci["document_date"] = this.set_date;
      podaci["restaurant_id"] = this.$store.state.restaurant.id;
      podaci["created_by"] = this.$store.state.user.user.id;
      podaci["dispatched_by"] = this.user_give_out;
      podaci["processed_by"] = null;
      podaci["received_by"] = this.user_give_in;
      podaci["notes"] = this.warehouse_note;
      podaci["groceries"] = this.selected_groceries;
      warehouseService
        .saveGroceriesWarehouse(podaci)
        .then(({ data }) => {
          this.selected_groceries = data;
          this.showSuccessSnackbar(this.$t("saved_successfully"));
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_saving_warehouse_data"));
        });
      this.give_out = false;
      this.loadGrocery();
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },

    toogleMeals() {
      if (this.search1.length > 0) {
        this.search1 = [];
      } else if (this.search1.length == 0) {
        let arr = [];
        this.search1 = {};
        for (let it in this.report) {
          this.search1[it] = {};
          for (let n in this.report[it]) {
            arr.push(n);
            // arr[it].push(this.report[it][n])
            // this.search1[it][n] = arr
          }
        }
        this.search1 = arr;
      }
    },

    loadGrocery() {
      groceryService
        .getWarehouseGroceries()
        .then((res) => {
          this.desserts = res.data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_groceries"));
        });
    },

    takeOff() {
      this.selected_groceries = [];
      this.give_out = true;
      this.total.filter((item) => {
        if (item.checked) {
          item.amount = item.quantity;
          this.selected_groceries.push(item);
        }
      });
    },

    load() {
      const params = {
        date: moment(this.dates[0]).format("YYYY-MM-DD"),
        dateTo: moment(this.dates[1]).format("YYYY-MM-DD"),
      };
      warehouseService
        .getDailyWarehouseReport(this.$store.state.restaurant.id, params)
        .then((res) => {
          let arr = [];
          this.report = res.data;
          for (let i in res.data) {
            for (let n in res.data[i]) {
              arr.push(n);
            }
          }
          this.report = res.data;
          this.search1 = arr;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_report"));
        });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    editItemUlaz(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogUlaz = true;
    },

    editItemIzlaz(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogIzlaz = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeIzlaz() {
      this.dialogIzlaz = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeUlaz() {
      this.dialogUlaz = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closePopis() {
      this.dialogPopis = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    print(id) {
      const prtHtml = document.getElementById(id).innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      // Get the current date
      const currentDate = moment().format("DD.MM.YYYY HH:mm:ss");
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                                    <html>
                                      <head>
                                        ${stylesHtml}
                                        <style>
                                          table {
                                          font-family: arial, sans-serif;
                                          border-collapse: collapse;
                                          width: 100%;
                                          }
                                          td, th {
                                          border: 1px solid rgba(0, 0, 0, 0.12);
                                          text-align: left;
                                          padding: 8px;
                                          }
                                          tr:nth-child(even) {
                                          background-color: #f1f1f1;
                                          }
                                          /* Hide the footer when printing */
                                            @media print {
                                              .v-data-footer, .nar, .firme {
                                                display: none;
                                              }
                                              .naslov {
                                                display: block;
                                                margin-bottom: 1px;
                                                margin-top: 20px;
                                              }
                                              .headline_tab {
                                                display: block !important;
                                              }
                                              .headline_mag {
                                                margin-bottom: -40px !important;
                                              }
                                              #st_mag div.v-data-table > div.v-data-table__wrapper {
                                                margin-top: -50px !important;
                                              }
                                              #st_mag header {
                                                margin-bottom: -82px !important;
                                              }
                                            }
                                          </style>
                                      </head>
                                      <body>
                                       <div class="print-date" style="margin-top: 20px; text-align: left;font-weight: 700">
                                           ${this.$t("order_date")}: ${this.formatDate(
        this.dates[0]
      )} - ${this.formatDate(this.dates[1])}</h2>
                                        </div> <br>
                                        ${prtHtml}
                                        <div class="print-date" style="margin-top: 20px; text-align: left;font-weight: 700">
                                          ${this.$t(
                                            "report_creation_datetime"
                                          )}: ${currentDate}
                                        </div>
                                      </body>
                                    </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },

    save() {
      this.editedItem.grocery_id = this.editedItem.id;
      let _editedItem = this.editedItem;
      let _editedIndex = this.editedIndex;
      warehouseService
        .updateWarehouseItem(this.editedItem)
        .then((res) => {
          Object.assign(this.desserts[_editedIndex], _editedItem);
          this.showSuccessSnackbar(this.$t("saved_successfully"));
          this.close();
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_saving_warehouse_data"));
        });
    },
  },
  computed: {
    total() {
      if (this.report) {
        let a = [];
        for (let item in this.report) {
          for (let item2 in this.report[item]) {
            this.report[item][item2]["groceries"].forEach((grocery) => {
              let index = a.findIndex((i) => i.name === grocery.name);
              if (index > -1) {
                a[index] = {
                  quantity:
                    a[index]["quantity"] +
                    this.report[item][item2]["quantity"] * grocery.quantity,
                  measure: grocery["measure"],
                  name: grocery.name,
                  code: grocery.code,
                  id: grocery.id,
                  checked: false,
                };
              } else {
                a.push({
                  quantity: this.report[item][item2]["quantity"] * grocery.quantity,
                  measure: this.report[item][item2].groceries.find(
                    (i) => i.name === grocery.name
                  )["measure"],
                  code: grocery.code,
                  name: grocery.name,
                  id: grocery.id,
                  checked: false,
                });
              }
            });
          }
        }

        return a;
      }
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("add_warehouse")
        : this.$t("edit_warehouse");
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
};
</script>
<style>
.headline_tab {
  display: none;
}
</style>
